module.exports = __webpack_public_path__ + "static/media/cinema.6b27ffbd.jpg";